import { useMemo } from 'react';
import { useStore } from 'effector-react';
import {
  $GateLayerAnimationTab,
  $componentLayerBatchSelected,
  $editingComponentLayer,
} from '@stores/editingComponentLayerStores';
import { $loadedScene } from '@stores/loadedStore';
import { $viewMode } from '@stores/viewModeStores';
import { LayerItem } from './LayerItem';
import { LayerItemEmpty } from './LayerItemEmpty';

export function SceneComponentLayers() {
  const scene = useStore($loadedScene);
  const editing = useStore($editingComponentLayer);
  const viewMode = useStore($viewMode);
  const batchSelected = useStore($componentLayerBatchSelected);
  const editingTab = useStore($GateLayerAnimationTab.state);

  const list = useMemo(() => {
    let layers = scene?.config.components ?? [];
    layers = layers.filter((x) => x.visible);
    if (editing) {
      const index = layers.findIndex((x) => x.id === editing.layer.id);
      if (index > -1) {
        layers[index] = { ...editing.layer };
      } else {
        layers.push({ ...editing.layer });
      }
    }
    if (viewMode === 'pc') {
      layers = layers.filter((layer) => layer.devices.includes(1));
    } else if (viewMode === 'mobile') {
      layers = layers.filter((layer) => layer.devices.includes(0));
    }
    return layers;
  }, [scene, editing, viewMode]);

  if (!scene) return null;

  return (
    <div className="pointer-events-none absolute inset-0 select-none">
      {list.map((layer) => {
        return layer.icon.mediaUrl ? (
          <LayerItem
            key={layer.id}
            data={layer}
            sceneId={scene.id}
            editingTab={editing?.layer.id === layer.id ? editingTab : null}
            isBatchSelected={batchSelected.has(layer.id)}
            type={viewMode === 'mobile' ? 'mobile' : 'desktop'}
          />
        ) : (
          <LayerItemEmpty key={layer.id} />
        );
      })}
    </div>
  );
}

export default SceneComponentLayers;
